// 20.1.2.1 Number.EPSILON
var $export = require('./_export');

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/es6.number.epsilon.js
// module id = 324
// module chunks = 0